<div class="wrapper">
  <app-sidebar></app-sidebar>
  <div class="main-panel">
    <app-navbar></app-navbar>
    @if (isLoading()) {
      <div class="wrap-spinner d-flex align-items-center justify-content-center">
        <div class="spinner-grow text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    }
    <div [ngClass]="{'d-none': isLoading()}">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>
